<div class="modal-header">
  <rask-header size="2">{{header}}</rask-header>
</div>
<div class="modal-body">
  {{content}}
</div>
<div class="modal-footer">
  <div class="w-100">
    <rask-button color="secondary" (click)="activeModal.close('ok')" negative>{{'NAVIGATION_UNSAVEDDATA_BUTTON_YES' | translate}}</rask-button>
    <div class="float-end">
      @if (showSave) {
        <rask-button color="primary" (click)="activeModal.close('save')">{{'NAVIGATION_UNSAVEDDATA_BUTTON_SAVE' | translate}}</rask-button>
      }
      <rask-button color="secondary" (click)="activeModal.close('cancel')" id="cancel" autofocus>{{'NAVIGATION_UNSAVEDDATA_BUTTON_CANCEL' | translate}}</rask-button>
    </div>
  </div>
</div>
